import { Link } from "react-router-dom";

export default function FinalCTA() {
  return (
    <section className="relative py-28 lg:py-44 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/30f3b7d0bd2d171144bb7296ac54ccba.jpg"
          alt="Schedule your pre-purchase car inspection"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-brand-black/88" />
        <div className="absolute inset-0 bg-gradient-to-br from-brand-gold/6 via-transparent to-brand-gold/4" />
      </div>

      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/35 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/35 to-transparent pointer-events-none" />
      <div className="absolute top-10 left-10 w-20 h-20 border-l-2 border-t-2 border-brand-gold/22 rounded-tl-xl pointer-events-none" />
      <div className="absolute bottom-10 right-10 w-20 h-20 border-r-2 border-b-2 border-brand-gold/22 rounded-br-xl pointer-events-none" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-6 flex items-center justify-center gap-3">
          <span className="w-10 h-px bg-brand-gold" />
          Don&apos;t Buy a Lemon
          <span className="w-10 h-px bg-brand-gold" />
        </p>

        <h2 className="font-serif text-4xl lg:text-6xl font-bold text-brand-white leading-tight mb-5">
          Protect Your Purchase<br />
          <span className="text-brand-gold italic">Before You Sign.</span>
        </h2>

        <p className="font-sans text-lg text-brand-gray-light leading-relaxed max-w-2xl mx-auto mb-4">
          One 450-point on-site inspection. Starting at <strong className="text-brand-white">$139</strong>. Speak directly to your inspector. Know exactly what you&apos;re buying — before you spend a dollar.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-12 text-sm text-brand-gray font-sans">
          <span className="flex items-center gap-1.5"><i className="ri-map-pin-2-line text-brand-gold" /> New York</span>
          <span className="text-brand-gold/30">·</span>
          <span className="flex items-center gap-1.5"><i className="ri-map-pin-2-line text-brand-gold" /> New Jersey</span>
          <span className="text-brand-gold/30">·</span>
          <span className="flex items-center gap-1.5"><i className="ri-map-pin-2-line text-brand-gold" /> Connecticut</span>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2.5 px-10 py-5 bg-brand-gold text-brand-black font-sans font-bold text-sm tracking-wide rounded-full hover:bg-brand-gold-light transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl shadow-brand-gold/20"
          >
            <i className="ri-search-line" />
            Schedule a 450-Point Inspection
          </Link>
          <a
            href="tel:5169833800"
            className="inline-flex items-center justify-center gap-2.5 px-10 py-5 border border-brand-gold/50 text-brand-gold font-sans font-medium text-sm tracking-wide rounded-full hover:bg-brand-gold/10 hover:border-brand-gold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line" />
            Call Now: (516) 983-3800
          </a>
        </div>

        <p className="mt-6 font-sans text-xs text-brand-gray">
          Also available at{" "}
          <a href="tel:7182297594" className="text-brand-gold/80 hover:text-brand-gold transition-colors">
            (718) 229-7594
          </a>
        </p>
      </div>
    </section>
  );
}
